var authStoreMutations;
(function (authStoreMutations) {
    authStoreMutations["SET_AUTH"] = "SET_AUTH";
    authStoreMutations["CLEAR_AUTH"] = "CLEAR_AUTH";
    authStoreMutations["SET_LOGIN_ERR_MSG"] = "SET_LOGIN_ERR_MSG";
})(authStoreMutations || (authStoreMutations = {}));
export default authStoreMutations;
